import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CodeClub } from 'app/shared/models/class/club/club';
import { UserAdmin } from 'app/shared/models/class/user/user';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserAdminService } from 'app/shared/services/user-admin/user-admin.service';

@Component({
  selector: 'app-open-dialog-admin-user',
  templateUrl: './open-dialog-admin-user.component.html',
  styleUrls: ['./open-dialog-admin-user.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OpenDialogAdminUserComponent implements OnInit {

  form!: UntypedFormGroup;
  userToEdit: UserAdmin;
  actors: CodeClub[] = [];
  roles: any[] = [];
  isLoading!: boolean;

  constructor(
    public dialogRef: MatDialogRef<OpenDialogAdminUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly userAdminService: UserAdminService,
    private readonly uiService: UiService
  )
  {
    this.userToEdit = data['user'];
    this.actors = data['actors'];
  }

  ngOnInit(): void {
    this.initForm();
    this.init();
  }

  cancel(): void { this.dialogRef.close(); }

  save(): void {
    this.isLoading = true;
    const formValue = this.form.value;
    const userToPost: UserAdmin = {
      key: this.userToEdit ? this.userToEdit.key : null as any,
      userName: formValue.userName,
      role: formValue.role.code,
      actorKey: formValue.actor?.key,
      firstName: formValue.firstName,
      lastName: formValue.lastName,
      email: formValue.email,
      phoneNumber: null as any,
      address: null as any,
      postalCode: null as any,
      city: null as any,
      country: null as any,
      isInitialized: !this.userToEdit ? true : this.userToEdit.isInitialized
    };

    if (this.userToEdit) {
      this.userAdminService.put(userToPost).subscribe({
        next: data => {
          this.isLoading = false;
          data.key = userToPost.key!;
          this.uiService.showSnackbar(`L'utilisateur ${this.userToEdit.firstName} ${this.userToEdit.lastName} a été modifié avec succès.`);
          this.dialogRef.close(data);
        },
        error: () => {
          this.isLoading = false;
          this.uiService.showSnackbar(`Une erreur est survenue durant l'édition d'un utilisateur.`);
        }
      });
    } else {
      this.userAdminService.post(userToPost).subscribe({
        next: data => {
          this.isLoading = false;
          this.uiService.showSnackbar(`L'utilisateur ${userToPost.firstName} ${userToPost.lastName} a été ajouté avec succès.`);
          this.dialogRef.close(data);
        },
        error: err => {
          this.isLoading = false;
          if (err.error === "username_exists") {
            this.uiService.showSnackbar(`Identifiant déjà existant.`);
          } else {
            this.uiService.showSnackbar(`Une erreur est survenue durant la création d'un utilisateur.`);
          }
        }
      });
    }
  }

  private init(): void {
    this.userAdminService.getRoles().subscribe({
      next: data => {
        this.roles = data;
        if (this.userToEdit) {
          const actor = this.actors.find(a => a.key === this.userToEdit.actorKey);
          this.form.controls['actor'].setValue(actor);
          const role = this.roles.find((r) => r.code === this.userToEdit.role);
          this.form.controls['role'].setValue(role);
        }
      }
    });
  }

  private initForm(): void {
    let lastName = null;
    let firstName = null;
    let email = null;
    let userName = '';

    if (this.userToEdit) {
      lastName = this.userToEdit.lastName;
      firstName = this.userToEdit.firstName;
      email = this.userToEdit.email;
      userName = this.userToEdit.userName
    }

    this.form = this.formBuilder.group({
      userName: [userName, Validators.required],
      lastName: [lastName],
      firstName: [firstName],
      email: [email],
      role: [null, Validators.required],
      actor: [null]
    });
  }

}
